import { useMutation, UseMutationOptions, useQueryClient } from "react-query"
import { useApiClient } from "../../api-client/api-client.hooks"

type Params = {
  trackerId: string
  options?: UseMutationOptions
}

export const useStopUserTrackerMutation = (params: Params) => {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  const {
    trackerId,
    options
  } = params

  const query = useMutation(
    ['active-trackers', 'stop'],
    async () => {
      const response = await apiClient.stopUserTracker(trackerId)

      if (!response.ok) {
        throw {
          errors: response.errors,
          status: response.status,
        }
      }

      console.log(response)

      return response
    },
    {
      ...options,
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries('active-tracker')
        queryClient.invalidateQueries('activities', { exact: false })
        queryClient.invalidateQueries('time-logs', { exact: false })

        // @ts-ignore
        if (options && options.onSuccess) options.onSuccess(data, variables)
      }
    }
  )

  return query
}

export default useStopUserTrackerMutation